module.exports = __webpack_public_path__ + "static/media/ezviz.11291cab.png";